// extracted by mini-css-extract-plugin
export default {"container":"AssetItemInfo_container__5kIXg","button":"AssetItemInfo_button__E5GdZ","asset_item_wrapper":"AssetItemInfo_asset_item_wrapper__v6Of7"};